import { Helmet } from "react-helmet-async";

const DEFAULT_IMAGE = "https://cocoamayapatisserie.com/cocoamaya-bakery.png";
const DEFAULT_DESC =
  "Cocoamaya Patisserie — Hand-crafted cakes, pastries, hampers and artisan desserts. Same-day delivery across Mumbai. Established 2017.";

/**
 * SEOHead: single source of truth for per-page title / description / OG tags.
 * Every page should render one of these. Product detail can pass extra jsonLd.
 */
export const SEOHead = ({
  title = "Cocoamaya Patisserie — Fresh Cakes & Artisan Desserts in Mumbai",
  description = DEFAULT_DESC,
  image = DEFAULT_IMAGE,
  url,
  ogType = "website",
  jsonLd,
  keywords,
  noindex = false,
}) => {
  const clean = (s) => (s || "").replace(/\s+/g, " ").trim();
  const desc = clean(description);
  const trimmed = desc.length > 160 ? desc.slice(0, 157) + "…" : desc;
  const kw = clean(keywords);
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={trimmed} />
      {kw && <meta name="keywords" content={kw} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {url && <link rel="canonical" href={url} />}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={trimmed} />
      <meta property="og:image" content={image} />
      {url && <meta property="og:url" content={url} />}
      <meta property="og:site_name" content="Cocoamaya Patisserie" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={trimmed} />
      <meta name="twitter:image" content={image} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};
